import { ReactNode, useEffect } from 'react';
import { LoadingProvider } from '@/contexts/Loading';
import { windowInFrame } from '@/utils/window-in-frame';

export type TAppProvidersProps = {
  children: ReactNode;
};

const THREE_CX_SCRIPT_ID = 'tcx-callus-js';
const THREE_CX_SCRIPT_SRC =
  'https://cdn.3cx.com/livechat/v1/callus.js';

export const Layout = ({ children }: TAppProvidersProps) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (windowInFrame()) return;
    if (document.getElementById(THREE_CX_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = THREE_CX_SCRIPT_ID;
    script.src = THREE_CX_SCRIPT_SRC;
    script.defer = true;
    document.head.appendChild(script);
  }, []);

  return <LoadingProvider>{children}</LoadingProvider>;
};
